const types = {
  VTERM_SET_CONFIG: "VTERM_SET_CONFIG",
  VTERM_SET_UNIT_TOKEN: "VTERM_SET_UNIT_TOKEN",
  VTERM_SET_TRANSACTIONS: "VTERM_SET_TRANSACTIONS",
  VTERM_SALE_RESULT: "VTERM_SALE_RESULT",
  VTERM_CLEAR_SALE_RESULT: "VTERM_CLEAR_SALE_RESULT",
  VTERM_SET_LOADING: "VTERM_SET_LOADING",
};

export default types;
